import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { auditApi } from "@/api/audit";
import type { AuditLogFilters } from "@/types/audit";

export const auditKeys = {
  all: ["audit"] as const,
  logs: (filters: AuditLogFilters) =>
    [...auditKeys.all, "logs", filters] as const,
  filters: () => [...auditKeys.all, "filters"] as const,
};

export function useAuditLogs(filters: AuditLogFilters) {
  return useQuery({
    queryKey: auditKeys.logs(filters),
    queryFn: () => auditApi.getLogs(filters),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}

export function useAuditFilterOptions() {
  return useQuery({
    queryKey: auditKeys.filters(),
    queryFn: () => auditApi.getFilterOptions(),
    staleTime: 5 * 60 * 1000,
  });
}
